export default __webpack_public_path__ + "static/media/lentes-rocker.bf804044.png";